export const SET_STORE_USER = "SET_STORE_USER";

export const SET_ID_STORE_USER = "SET_ID_STORE_USER";

const user = (state = null, action) => {
  switch (action.type) {
    case SET_STORE_USER:
      return action.payload;
    case SET_ID_STORE_USER:
      return { ...state, storeId: action.payload };
    default:
      return state;
  }
};

export default user;
